import { NavBar } from "./components/NavBar";
import { useState, useEffect } from "react";
import React from "react";
import ReactPlayer from "react-player/youtube";
import InfoCard from "./components/InfoCard";
import Footer from "./components/Footer";
import SidePopUp from "./components/SidePopUp";
import ButtonShadow from "./components/ButtonShadow";
import QuestionFormatFaq from "./components/QuestionFormatFaq";
import TrustPilot from "./components/TrustPilot";
import { initializeTalkdesk, openTalkdesk } from './helpers/talkdeskHelper';
import { initializeEmailButton } from './helpers/emailButtonHelper';

import { AppContext } from './AppContext';

function Home() {
  const [data, setData] = useState({ questions: [] });
  const [showPopup, setShowPopup] = useState(false); 
  const [hasToken, setHasToken] = useState(false);

  const questions = {
    "faqHeading": "Frequently asked questions",
    "faqs": [
      {
        "id": 1,
        "label": "How much could I receive?",
        "value": "The amount that could be won is dependent on a number of factors.\n\nAs each case progresses, we will be able to give a more accurate depiction of this figure, so be sure to check your emails after signing up to My Diesel Claim for updates."},
      { "id": 2, "label": "How much will I be charged?", "value": "Your My Diesel Claim is being litigated on a No-Win, No-Fee basis, meaning it costs you nothing to join. If we do not win you compensation, we will cover all legal costs and you will not pay a penny.\n\nIf the case is won, a percentage will be deducted from your compensation costs to cover legal fees, court fees, and our success fee. Unlike some other firms, we cap our fees at a maximum of 50% inclusive of VAT, although the actual fee may be as low as 20%.\n\nIf you purchased or leased your vehicle in Scotland, your claim will be dealt with by our Scottish team. Scottish claims are also pursued on a ‘No-Win, No-Fee basis’, but different fee terms apply.\n\nType in your vehicles model at the top of this page for more information and to start your claim in under a minute.\n\nFor peace of mind, feel free to head to the Money Saving Expert website where a comparison of all the firms litigating the claim and their costs are laid out." },
      { "id": 3, "label": "Why should I choose Pogust Goodhead?", "value": "Pogust Goodhead is paving the way for emissions claims in the UK, and our team of legal professionals are unrivalled in group litigation claims. We were integral in the £193M settlement with VW, and we are continuing to fight for justice for all UK drivers. We already have more drivers signed up than all other UK firms combined, meaning more people have put their trust in us to handle their claims. You can read more about the diesel emissions claim on the Money Saving Expert website." },
      {"id": 4, "label": "Have any UK drivers received compensation payments?", "value": "Yes. In May 2022, Volkswagen agreed to a £193million payment for around 91,000 drivers in an out of court UK settlement.\n\nThe settlement was a part of our VW1 claim for cars with EA189 engines, which were first registered between 2008 and 2015. Whilst this settlement is the first of its kind in the UK, we are confident it will not be the last.\n\nWe are still pursuing claims against the Volkswagen Group for vehicles registered from 2009 – 2020 and you can sign up now."},
      {"id": 5, "label":"Why is it important to claim?", "value":"We believe customers have been deliberately misled about the amount of emissions their vehicles were producing, and think customers should be compensated for the following reasons:\n\nThe increased Nitrogen Dioxide levels are harmful to children, adults, and the environment\n\nCustomers may have experienced higher fuel bills and maintenance costs\n\nThe performance of these vehicles was negatively affected.\n\nYou can help the environment while making money by claiming back from your vehicle manufacturer. Input your vehicle model at the top of this page and start your claim in under a minute.  "},
      {"id":8, "label":"Which brands are involved?", "value":"Since Volkswagen were investigated in 2015, a number of car manufacturers have joined the scandal and have been investigated for diesel emissions fraud.\n\nThe brands include, but are not limited to:\n\nMercedes\n\nVauxhall\n\nFiat\n\nChrysler\n\nJeep\n\nRenault\n\nNissan\n\nAlfa Romeo\n\nSuzuki\n\nMany more\n\nPogust Goodhead are litigating against more manufacturers than any other UK law firm. You can read more on this on the Money Saving Expert website."},
      {"id":10, "label":"Can I claim for more than one vehicle?", "value":"Yes. You are entitled to sign up for every diesel vehicle you owned, or still own, within the time period.\n\nPlease be aware that, if you sign up with multiple vehicles, then you may receive multiple communications and requests for information. All emails will contain matter reference and VRN, so please check each correspondence carefully before submitting."},
      {"id":11, "label":"How do I know if my Volkswagen has an EA189 engine?", "value":"To find out your car’s engine type, you’ll need your 17 digit Vehicle Identification Number (VIN). This is usually stamped on the lower corner of the windshield on the driver’s side and on the door frame of the driver’s side door.  Some vehicles may also have their VIN stamped on a metal plate under the hood, near the engine compartment.  Please enter the VIN into an online VIN decoder and it will tell you your engine model. If your car has an EA189 Engine, Pogust Goodhead will not be able to represent you further.  If you tick ‘not sure’ and we later establish you have an EA189, we will have to automatically terminate your client retainer."},
      {"id":12, "label":"Can I claim in the Scottish NOx emissions cases?", "value":"We are no longer taking on new clients for the Scottish NOx emissions cases.  You may still be able to bring a claim in Scotland with another firm and we recommend you seek advice from a Scottish solicitor as soon as possible."}
    ],
  }

  const togglePopup = () => {
    document.querySelector(".right-popup").classList.add("visible");
  };

  useEffect(() => {
    setTimeout(() => {
      setShowPopup(true);
    }, 5000);
  }, []);


  useEffect(() => {
    initializeEmailButton();
  }, []);


    useEffect(() => {
      setData(questions);
    }, []);

    useEffect(() => {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has("TokenisedMatterId")) {
        setHasToken(true);
      }
    }, []);


  return (
    <div className="App">
      {showPopup && !hasToken ? <SidePopUp/> : null}
      <div className="pageWrapper">
        <NavBar />
      </div>

      <div className="topSection">
  
          <div className="topContent">
            <div className="questionsFormat2Content">
              <p>Sign-ups for new diesel emissions claims are <span className="text-bold">now closed</span>.</p>
            </div>
       
          </div>
   
      </div>
      <div className="middleSction"></div>
      <div className="bottomSection">
        <div className="infoCardsSectionWrapper">
          <div className="infoCardsWrapper">
            <div className="infoSection">
              <div className="infoSectionItem">
                <div className="infocardTitle">What is My Diesel Claim?</div>
                <p>
                  My Diesel Claim investigates diesel emissions fraud by car manufacturers between 2009 and 2020, aiming to compensate drivers of affected
                  vehicles with up to £10,000.
                </p>
                <InfoCard copy="Volkswagen settled for £193M in May 2022 due to their involvement in the emissions scandal, setting a precedent for future cases." />

                <p>
                  Numerous car brands, including Mercedes, VW, Audi, BMW, and others, are implicated in the scandal, with some already paying substantial
                  compensation. Pogust Goodhead emphasises the importance of holding corporations accountable for environmental damage.
                </p>
              </div>
              <div className="infoSectionItem">
                <p className="infocardTitle">What are cheat devices?</p>
                <p>
                  Defeat devices, also commonly called cheat devices, are fitted into diesel vehicles to falsify emissions levels by using test conditions to
                  pass regulatory checks.
                </p>
                <p>
                  Real-world driving conditions produce much higher emissions levels, meaning affected vehicles would not pass regulatory checks without the use
                  of defeat devices.
                </p>
                <p>Emissions laws are therefore being cheated and excess emissions can have consequences for the environment and the health of the public.</p>
               <InfoCard copy="You can read more about the diesel emissions fraud claim on the Money Saving Expert (MSE) website." />
              </div>
            </div>
            <div className="infoSectionBottom">
              <p className="youTubeHeading">My Diesel Claim Webinar</p>
              <div className="youTubeWrapper">
                <div className="youTubeConatiner infoSectionItem">
                  <ReactPlayer className="reactPlayer" url="https://youtu.be/FKr56qf-5iU" width={"100%"} height={"100%"} controls={true} />
                </div>
              </div>
            </div>
           
          </div>
        </div>

        <div>
          <TrustPilot />
        </div>

        <div className="faqWrapper">
          <QuestionFormatFaq faqs={data.faqs} faqHeading={data.faqHeading} />
        </div>

        <Footer />
      </div>
      {/* <Questions vehicleData={vehicleData} index={index} setIndex={setIndex} setRegPlate={setRegPlate} regPlate={regPlate} answers={answers} setAnswers={setAnswers} setJourney={setJourney} journey={journey} /> */}
    </div>
  );
}

export default Home;
